import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
  mutation sampleNotificationTemplate(
    $id: Int,
    $name: String,
    $template: String,
  ) {
  sampleNotificationTemplate(
    id: $id,
    name: $name,
    template: $template,
  ) {
      success
    }
  }
`;

export function useSampleNotificationTemplate() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(query, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.sampleNotificationTemplate.success);
      }
    });
  };
  return { data, isLoading, run };
}
